<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>Unsubscribe chat</h2>
        </template>
        <template v-slot:body>
            <p>
                <strong>Are you sure you want to unsubscribe to this conversation?</strong>
            </p>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <a
                    type="button"
                    class="btn btn--transparent-outlined"
                    :href="unsubscribeUrl"
                >
                    Unsubscribe
                </a>
                <button
                    type="button"
                    class="btn btn--secondary"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        unsubscribeUrl: {
            required: true,
        },
    },
    methods: {
        onCancel() {
            this.$emit('close');
        },
    },
};
</script>
